/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_itemSearch" | "SbRespRefineMenuFilterPrice_itemSearch" | "SbSharedRefineMenuFilterStone_itemSearch" | "SbSharedRefineMenuFilterMetal_itemSearch" | "SbSharedRefineMenuFilterColor_itemSearch" | "SbMobileRefineMenuFilterPrice_itemSearch" | "SbSharedRefineMenuFilterStyle_itemSearch" | "SbSharedRefineMenuFilterOrigin_itemSearch" | "SbSharedRefineMenuFilterPeriod_itemSearch" | "SbRespRefineMenuFilterCategory_itemSearch" | "SbRespRefineMenuFilterStoneCut_itemSearch" | "SbSharedRefineMenuFilterCreator_itemSearch" | "SbMobileRefineMenuFilterStoneCut_itemSearch" | "SbMobileRefineMenuFilterCategory_itemSearch" | "SbSharedRefineMenuFilterMaterial_itemSearch" | "SbRespRefineMenuFilterDeliveryOptions_itemSearch" | "SbMobileRefineMenuFilterDeliveryOptions_itemSearch" | "SbSharedRefineMenuFilterItemType_itemSearch" | "SbSharedRefineMenuFilterJewelryType_itemSearch" | "SbRespRefineMenuFilterDimensions_itemSearch" | "SbRespRefineMenuFilterCaratWeight_itemSearch" | "SbMobileRefineMenuFilterDimensions_itemSearch" | "SbMobileRefineMenuFilterCaratWeight_itemSearch" | "SbSharedRefineMenuFilterAvailability_itemSearch" | "SbSharedRefineMenuFilterMatchingSets_itemSearch" | "SbSharedRefineMenuFilterGender_itemSearch" | "SbSharedRefineMenuFilterFraming_itemSearch" | "SbSharedRefineMenuFilterRingSize_itemSearch" | "useMeasurementUnit_itemSearch" | "SbSharedRefineMenuFilterArtOrientation_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilters_itemSearch";
};
export type SbSharedRefineMenuFilters_itemSearch$data = SbSharedRefineMenuFilters_itemSearch;
export type SbSharedRefineMenuFilters_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilters_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterColor_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStyle_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterPeriod_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterStoneCut_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemType_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterJewelryType_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCaratWeight_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCaratWeight_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterAvailability_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMatchingSets_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterGender_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterFraming_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterRingSize_itemSearch"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "kind": "LinkedField",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterArtOrientation_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();
(node as any).hash = 'fd8e9a5002d9cf4c25b687c9ea84716b';
export default node;
